import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { useState, useEffect } from "react";
import { Alert } from "@mui/material";
import axios from "axios";
import { getAllUsers } from "../../utils/utilsAPI";
import { decryptData } from "../../utils/cryptoUtils";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function CheckAssetModal({
  asset,
  assetLocations,
  handleClose,
  refreshAssets,
}) {
  const url = process.env.REACT_APP_URL;
  const [assetLocation, setAssetLocation] = useState(asset.locationId);
  const [forSelf, setForSelf] = useState(
    localStorage.getItem("asset") == process.env.REACT_APP_ADMIN_ID
      ? true
      : null
  );
  const [users, setUsers] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(0);
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlignment = (event, newAlignment) => {
    setForSelf(newAlignment);
  };

  useEffect(() => {
    //Get Users
    getAllUsers().then((res) => {
      let _users = res.users;
      let decryptedData = _users.map((u, i) => {
        return {
          ...u,
          email: decryptData(u.email, process.env.REACT_APP_ATT_KEY),
        };
      });

      setUsers(decryptedData);
    });
  }, []);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const handleValidation = () => {
    setDisable(true);

    if (assetLocation === 0) {
      handleAlert("Please select a location", "warning");
    } else if (!asset.checkedIn) {
      handleCheckIn();
    } else if (
      localStorage.getItem("access") == process.env.REACT_APP_ADMIN_ID
    ) {
      if (forSelf === null) {
        handleAlert(
          "Please select if it is for yourself or someone else",
          "warning"
        );
      } else if (!forSelf && selectedEmployee === 0) {
        handleAlert("Please select a colleague", "warning");
      } else {
        handleCheckOut();
      }
    } else {
      handleCheckOut();
    }
  };

  const handleCheckOut = async () => {
    const reqBody = {
      currentUser: parseInt(localStorage.getItem("userId")),
      currentUsername: localStorage.getItem("username"),
      assetId: asset.assetId,
      assetName: asset.assetName,
      locationId: assetLocation,
      forSelf: forSelf,
      selectedEmployee: selectedEmployee
        ? selectedEmployee
        : parseInt(localStorage.getItem("userId")),
    };

    await axios
      .post(`${url}/assets/check-out`, reqBody)
      .then((res) => {
        handleAlert("Asset checked out", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Could not check out asset", "error");
      });
  };

  const handleCheckIn = async () => {
    const reqBody = {
      currentUser: parseInt(localStorage.getItem("userId")),
      currentUsername: localStorage.getItem("username"),
      assetId: asset.assetId,
      locationId: 4,
      assetName: asset.assetName,
    };

    await axios
      .post(`${url}/assets/check-in`, reqBody)
      .then((res) => {
        handleAlert("Asset checked in", "success", true, 500);
      })
      .catch((err) => {
        handleAlert("Could not check in asset", "error");
      });
  };

  return (
    <Box className="check-asset-modal">
      <section className="check-asset-section">
        <h2>Check {asset.checkedIn ? "Out" : "In"} Asset</h2>

        {asset.checkedIn ? (
          <>
            <p>
              Where will this asset be located while you have it checked out
            </p>
            <form className="check-asset-form">
              <select
                value={assetLocation}
                onChange={(e) => {
                  setAssetLocation(parseInt(e.target.value));
                }}
              >
                <option value={0}>Select a location</option>
                {assetLocations && assetLocations.length > 0
                  ? assetLocations.map((l, i) => {
                      if (l.locationId != 4) {
                        return (
                          <option key={i} value={l.locationId}>
                            {l.locationName}
                          </option>
                        );
                      }
                    })
                  : null}
              </select>
              {asset.checkedIn ? (
                <>
                  {localStorage.getItem("access") ==
                  process.env.REACT_APP_ADMIN_ID ? (
                    <section className="admin-check-section">
                      <p>
                        Are you checking this {asset.checkedIn ? "out" : "in"}{" "}
                        for yourself or another colleague?
                      </p>
                      <ToggleButtonGroup
                        value={forSelf}
                        exclusive
                        onChange={handleAlignment}
                        aria-label="text alignment"
                        className="admin-btns"
                      >
                        <ToggleButton value={true}> Myself</ToggleButton>
                        <ToggleButton value={false}>Someone else</ToggleButton>
                      </ToggleButtonGroup>
                    </section>
                  ) : null}
                  {!forSelf && forSelf != null ? (
                    <section className="admin-select-staff">
                      <p>Select who it is on behalf of</p>
                      <select
                        value={selectedEmployee}
                        onChange={(e) =>
                          setSelectedEmployee(parseInt(e.target.value))
                        }
                      >
                        <option value={0}>Select Employee</option>
                        {users && users.length > 0
                          ? users.map((u, i) => {
                              return (
                                <option key={i} value={u.userId}>
                                  {u.userName}
                                </option>
                              );
                            })
                          : null}
                      </select>
                    </section>
                  ) : null}
                </>
              ) : null}
            </form>
          </>
        ) : (
          <p>Are You sure you want to check this asset in?</p>
        )}

        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            variant="contained"
            color="error"
            onClick={() => handleClose(false)}
            disabled={disable}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={disable}
            onClick={handleValidation}
            color={asset.checkedIn ? "warning" : "success"}
          >
            {asset.checkedIn ? "Check out" : "Check in"}
          </Button>
        </section>
      </section>
    </Box>
  );
}
